export const dashboardConstants = {
  SEARCH: '[Dashboard] Search',
  SEARCH_SUCCESS: '[Dashboard] Search success',
  SEARCH_FAILURE: '[Dashboard] Search failure',
  GET_SINGLE: '[Dashboard] Get single hole',
  GET_SINGLE_SUCCESS: '[Dashboard] Get single hole success',
  GET_SINGLE_FAILURE: '[Dashboard] Get single hole failure',
  SAVE_FORM_FILTERS: '[Dashboard] Save form filter',
  CHANGE_MAP_ZOOM: '[Dashboard] Zoom changed',
  CHANGE_MAP_CENTER: '[Dashboard] Center changed',
  CHANGE_CLUSTER_SIZE: '[Dashboard] Change cluster size',
  RESET_SEARCH: '[Dashboard] Reset search',
  MASSIVE: '[Dashboard] Massive',
  MASSIVE_SUCCESS: '[Dashboard] Massive success',
  MASSIVE_FAILURE: '[Dashboard] Massive failure',
  GET_IMAGES: '[Dashboard] Get images',
  GET_IMAGES_SUCCESS: '[Dashboard] Get images success',
  GET_IMAGES_FAILURE: '[Dashboard] Get images failure',
  RESET_IMAGES: '[Dashboard] Reset images',
  SWITCH_IMAGE_LAYER: '[Dashboard] Switch image layer',
  SWITCH_HOLE_LAYER: '[Dashboard] Switch hole layer',
  GENERATING_MISSION: '[Dashboard] Generating mission',
  GENERATING_MISSION_SUCCESS: '[Dashboard] Generating mission success',
  GENERATING_MISSION_FAILURE: '[Dashboard] Generating mission failure',
  CERTIFY_PHOTO: '[Dashboard] Certify photo',
  CERTIFY_PHOTO_SUCCESS: '[Dashboard] Certify photo success',
  CERTIFY_PHOTO_FAILURE: '[Dashboard] Certify photo failure',
  TOGGLE_CERTIFIED_PHOTOS: '[Dashboard] Toggle certified photos',
  RIPARABLE_PHOTO: '[Dashboard] Riparable photo',
  RIPARABLE_PHOTO_SUCCESS: '[Dashboard] Riparable photo success',
  RIPARABLE_PHOTO_FAILURE: '[Dashboard] Riparable photo failure',
  MUST_BE_REPAIRED: '[Dashboard] Must be repaired',
  MUST_BE_REPAIRED_SUCCESS: '[Dashboard] Must be repaired success',
  MUST_BE_REPAIRED_FAILURE: '[Dashboard] Must be repaired failure'
}
